import request from '@/utils/Request';
import qs from 'qs';
import {LocationEndpoints} from "@/services/location/endpoints";
import {HREndpoints} from "@/services/hr/endpoints";

const list = async (params: Record<string, any>) => {
  const response = await request.authorizedAxios().get(LocationEndpoints.SITE_URI_V2, {params, paramsSerializer: params => qs.stringify(params, {indices: false})});
  return response?.data;
}

const update = async (id: string, params: Record<string, any>) => {
  const response = await request.authorizedAxios().put(`${LocationEndpoints.SITE_URI_V2}${id}/`, params);
  return response?.data;
}

const retrieve = async (id: string) => {
  const response = await request.authorizedAxios().get(`${LocationEndpoints.SITE_URI_V2}${id}/`);
  return response;
}

const destroy = async (id: string) => {
  const response = await request.authorizedAxios().delete(`${LocationEndpoints.SITE_URI_V2}${id}/`);
  return response;
}

const SiteService = {
  list,
  update,
  retrieve,
  destroy,
}

export default SiteService;
